module.exports = __webpack_public_path__ + "static/media/line.a1d48691.svg";